import { Theme } from '@core/enums/theme.enum';
import { ILazyComponent } from '@core/interfaces/lazy-loader/lazy-component.interface';

// Getter so that import expression is only evaluated if the property is accessed
export const ThemeComponentsMap: { [key in Theme]: Promise<ILazyComponent> } = {
  get [Theme.DEFAULT]() {
    return import('@core/modules/themes/default-theme/default-theme.component');
  },
  get [Theme.ORANGE]() {
    return import('@core/modules/themes/orange-theme/orange-theme.component');
  },
  get [Theme.INTERTICKET_PL]() {
    return import('@core/modules/themes/orange-theme/orange-theme.component');
  },
  get [Theme.AARHUSBRYGHUS]() {
    return import('@core/modules/themes/aarhusbryghus-theme/aarhusbryghus-theme.component');
  },
  get [Theme.OPLEVBRONDBY]() {
    return import('@core/modules/themes/oplevbrondby-theme/oplevbrondby-theme.component');
  },
  get [Theme.BEGHUSET]() {
    return import('@core/modules/themes/beghuset-theme/beghuset-theme.component');
  },
  get [Theme.MFA]() {
    return import('@core/modules/themes/mfa-theme/mfa-theme.component');
  },
  get [Theme.EVAALEXIS]() {
    return import('@core/modules/themes/evaalexis/evaalexis-theme.component');
  },
  get [Theme.TEATR_MALY]() {
    return import('@core/modules/themes/teatr-maly-theme/teatr-maly-theme.component');
  },
};
